let createStandardEventForm = require("../../createStandardEventForm");
var _ = require('ES/lib/lodash');

module.exports = createStandardEventForm({
    eventToInitialValues(event) {
        return {
            nonCSP: !event.nonCSP,
            salaried_job: _.get(event, 'flags_as_map.salaried_job.is_set', false),
            cspDivision: event.cspDivision || ""
        }
            ;
    },
    buildSchema() {
        return {
            nonCSP: {
                label: "Include on CSP application",
                type: "checkbox"
            },
            salaried_job: {
                label: "Performed for salaried job",
                type: "checkbox"
            },
            cspDivision: {
                label: "Company division",
                type: "text"
            }
        };
    },
    writeInputDataToEvent(data, event) {
        event.nonCSP = !data.nonCSP;
        event.cspDivision = data.cspDivision;
        _.set(event, 'flags_as_map.salaried_job.is_set', data.salaried_job);
    }
});



// WEBPACK FOOTER //
// ./src/components/main_view/event_area/tabs/misc/CSP.js